var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.83811 11.0049C3.83811 9.59117 4.25732 8.20919 5.04274 7.03372C5.82816 5.85825 6.94451 4.94208 8.25062 4.40107C9.55673 3.86006 10.9939 3.71851 12.3805 3.99432C13.767 4.27012 15.0407 4.95089 16.0403 5.95055C17.04 6.9502 17.7208 8.22384 17.9966 9.61041C18.2724 10.997 18.1308 12.4342 17.5898 13.7403C17.0488 15.0464 16.1326 16.1628 14.9572 16.9482C13.7817 17.7336 12.3997 18.1528 10.986 18.1528C9.09026 18.1528 7.27217 17.3997 5.93168 16.0592C4.59119 14.7187 3.83811 12.9006 3.83811 11.0049V11.0049ZM1.30216 11.0049C1.30093 9.08561 1.86914 7.20909 2.93486 5.61288C4.00058 4.01666 5.51591 2.77251 7.28904 2.03789C9.06216 1.30327 11.0134 1.11121 12.8957 1.48602C14.778 1.86083 16.5069 2.78567 17.8633 4.14347C19.2198 5.50126 20.143 7.23097 20.516 9.11367C20.889 10.9964 20.6951 12.9474 19.9587 14.7198C19.2224 16.4923 17.9768 18.0064 16.3796 19.0706C14.7823 20.1348 12.9053 20.7012 10.986 20.6981C8.41708 20.6948 5.95446 19.6722 4.13883 17.8548C2.3232 16.0374 1.30298 13.5738 1.30216 11.0049V11.0049Z",
    fill: "#B82024"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-2.07527e-08 10.7656L0 11.2349L1.30527 11.2349L1.30527 10.7656L-2.07527e-08 10.7656Z",
    fill: "#B82024"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6947 10.7656L20.6947 11.2349L22 11.2349L22 10.7656L20.6947 10.7656Z",
    fill: "#B82024"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7654 10.7653L10.7654 5.92338C9.49945 5.98094 8.30072 6.50946 7.40436 7.40524C6.50801 8.30103 5.97872 9.49943 5.92035 10.7653L10.7654 10.7653Z",
    fill: "#3A3975"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7654 11.2346L5.92035 11.2346C5.97936 12.5006 6.50876 13.6989 7.40491 14.5951C8.30105 15.4912 9.49941 16.0206 10.7654 16.0797L10.7654 11.2346Z",
    fill: "#3A3975"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2346 10.7653L16.0765 10.7653C16.0196 9.49947 15.4912 8.3007 14.5952 7.4047C13.6992 6.5087 12.5004 5.9803 11.2346 5.92338L11.2346 10.7653Z",
    fill: "#3A3975"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2346 11.2346L11.2346 16.0797C12.5005 16.0213 13.6989 15.492 14.5947 14.5956C15.4904 13.6993 16.019 12.5005 16.0765 11.2346L11.2346 11.2346Z",
    fill: "#3A3975"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7653 20.6947L10.7653 22L11.2346 22L11.2346 20.6947L10.7653 20.6947Z",
    fill: "#B82024"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7653 9.17912e-06L10.7653 1.3053L11.2346 1.3053L11.2346 9.15884e-06L10.7653 9.17912e-06Z",
    fill: "#B82024"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCore);
export default __webpack_public_path__ + "static/media/core.f876cd6b.svg";
export { ForwardRef as ReactComponent };